import gql from 'graphql-tag';

const deleteShoppingCart_MUTATION = gql`
  mutation deleteShoppingCart($_id: ID!) {
    deleteShoppingCart(_id: $_id)
  }
`;

export default deleteShoppingCart_MUTATION;
